<template>
  <picture>
    <source
      v-if="props.image?.landscape?.srcset"
      media="(orientation: landscape)"
      :srcset="props.image.landscape.srcset"
    />

    <source
      v-if="props.image?.portrait?.srcset"
      media="(orientation: portrait)"
      :srcset="props.image.portrait.srcset"
    />

    <source
      v-if="props.image?.custom?.srcset"
      :srcset="props.image.custom.srcset"
    />

    <img
      :src="src"
      :alt="props.alt"
      :loading="props.lazyLoad ? 'lazy' : 'auto'"
      :width="sizes?.width"
      :height="sizes?.height"
    />
  </picture>
</template>

<script>
export default {
  name: 'WidgetPicture',
}
</script>

<script setup>
const props = defineProps({
  image: Object,
  lazyLoad: Boolean,
  alt: {
    type: String,
    default: '',
  },
})

const src = computed(() => {
  if (props.image?.landscape?.url) {
    return props.image?.landscape?.url
  } else if (props.image?.portrait?.url) {
    return props.image?.portrait?.url
  } else if (props.image?.custom?.url) {
    return props.image?.custom?.url
  } else {
    return undefined
  }
})

const sizes = computed(() => {
  if (props.image?.landscape) {
    return {
      width: props.image.landscape.width,
      height: props.image.landscape.height,
    }
  } else if (props.image?.portrait) {
    return {
      width: props.image.portrait.width,
      height: props.image.portrait.height,
    }
  } else if (props.image?.custom) {
    return {
      width: props.image.custom.width,
      height: props.image.custom.height,
    }
  } else {
    return undefined
  }
})
</script>
